import React, { useEffect } from 'react'
import { useNavigate, generatePath } from 'react-router-dom'
import { Table } from 'react-bootstrap'

import { API, Router} from 'app'
import { MediumContainer } from 'component/Layout'
import { useDataLoader } from 'component/Util'

export const UserHomePage = () => {
    const profileLoader = useDataLoader()

    useEffect(() => void profileLoader.fetch(API.endpoints.USER_PROFILE_VIEW), [])
    return profileLoader.view((data) => {
        return <MediumContainer>
            <h4>User Profile</h4>
            <h5>Test sessions</h5>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Test handle</th>
                        <th>Course</th>
                        <th>Test status</th>
                    </tr>
                </thead>
                <tbody>
                    {data.testsessions.map((test, idx) => {
                        return <tr key={idx}>
                            <td>
                                <a href={generatePath(Router.routes.TESTSESSION.path, { handle: test.handle })}>
                                    {test.handle}
                                </a>
                            </td>
                            <td>
                                <a href={generatePath(Router.routes.COURSE_VIEW.path, { course_name: test.course_name })}>
                                    {test.course_name}
                                </a>
                            </td>
                            <td>{test.status}</td>
                        </tr>
                    })}
                </tbody>
            </Table>
            <h5>Subscriptions</h5>
            <pre>
                { JSON.stringify(data.subscriptions, null, 2) }
            </pre>
        </MediumContainer>
    })
}

